import { queryOptions } from "@tanstack/react-query";
import { VolumeApi } from "./volume-api";

export const payinAccountsWithAggregatedBalancesQuery = (
  merchantId: string,
  accessToken: string,
  applicationId: string,
) => {
  const api = new VolumeApi(accessToken, applicationId);
  return queryOptions({
    queryKey: ["payin-accounts", merchantId],
    queryFn: () => api.getPayinAccountsWithAggregateBalances({ merchantId }),
  });
};
